module.exports = __webpack_public_path__ + "img/slovakia.c9e87470.png";